// Copyright ©️ 2026 eVolve MEP, LLC

import { TwoPanelLayout } from 'app/Layout/TwoPanelLayout';
import { ShopSetupWrapper } from 'modules/Shop/ShopSetup/WorkCellSetup/ShopSetupPage/ShopSetupWrapper';
import { TaskTypesProvider } from 'modules/Shop/ShopSetup/WorkCellSetup/ShopSetupPage/TaskTypes/useTaskTypes';
import { WorkCellTaskAdder } from 'modules/Shop/ShopSetup/WorkCellSetup/ShopSetupPage/TaskTypes/WorkCellTaskAdder';
import { WorkCellSetupMainPanel } from 'modules/Shop/ShopSetup/WorkCellSetup/ShopSetupPage/WorkCellSetupMainPanel';

/** Layout and context wrapper around the WorkCellSetupMainPanel and WorkCellTaskAdder */
export const WorkCellSetupPage = () => (
  <TaskTypesProvider workCellSetup>
    <ShopSetupWrapper>
      <TwoPanelLayout mainPanel={<WorkCellSetupMainPanel />} detailPanel={<WorkCellTaskAdder />} />
    </ShopSetupWrapper>
  </TaskTypesProvider>
);
